import api from './api';

/**
 * Invoice settings live in their own admin-only table, not the public
 * `/settings` endpoint, because they include bank details.
 *
 * Every call resolves to the full `{ values, fields, numbering }` payload.
 */
export const billingSettingsService = {
  get: async () => (await api.get('/billing/settings')).data.data,

  /** Send only changed text keys. Image keys and `company_state_code` are rejected. */
  save: async (values) => (await api.put('/billing/settings', { settings: values })).data.data,

  uploadImage: async (key, file) => {
    const fd = new FormData();
    fd.append('image', file);
    return (await api.post(`/billing/settings/images/${key}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })).data.data;
  },

  deleteImage: async (key) => (await api.delete(`/billing/settings/images/${key}`)).data.data,

  /** `series`: 'invoice' (tax invoices) or 'proforma' (PI numbers). */
  setSequence: async (financialYear, nextNumber, series = 'invoice') =>
    (await api.post('/billing/settings/sequence', {
      financial_year: financialYear,
      next_number: nextNumber,
      series,
    })).data.data,
};
